<template>
    <ModalDefault
        :id="'view_admision_detail'" title="Vista de admisión" size="lg">
        <template #modal-body>
        <template v-if="admisionSeleccionada">
            <AdmisionView :admision="admisionSeleccionada"/>
        </template>
        </template>
    </ModalDefault>
</template>
<script setup lang="ts">
import type { ICitaAdmision } from '@/modules/Admision/interfaces';
import AdmisionView from '@/modules/Admision/views/Admision/AdmisionView.vue'
defineProps<{
    admisionSeleccionada: ICitaAdmision
}>()
</script>